<div class="gh-emoji-picker" [ngClass]="{ outOfFocus: outOfFocus }">
  <button [ngClass]="{ opened: showEmojiPickerPolygon }" (click)="toggleEmojiPicker($event)" aria-label="emoji picker" type="button" tabindex="-1">
    <rich-text-editor-icon [icon]="emojiIcon" [outOfFocus]="outOfFocus"></rich-text-editor-icon>
  </button>

  <div
    class="emoji-picker-modal"
    #emojiPickerContainer
    [class.top-position]="emojiPickerPosition === 'top'"
    [class.middle-position]="emojiPickerPosition === 'middle'"
    [class.bottom-position]="emojiPickerPosition === 'bottom'">
    <div
      [class]="{
        polygon: true,
        'polygon-top-position': emojiPickerPosition === 'top',
        'polygon-middle-position': emojiPickerPosition === 'middle',
        'polygon-bottom-position': emojiPickerPosition === 'bottom'
      }"
      [hidden]="!showEmojiPickerPolygon"></div>
  </div>
</div>
